import React from 'react';
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Card, CardBody, CardHeader, Col, Collapse, Row,Button} from "reactstrap";
import {Button as SementicBtn, Checkbox, Dropdown, Form, Icon, Input} from "semantic-ui-react";
import TxtLbl from "../../../../components/Input/Input/TxtLbl";
import TxtAreaLbl from "../../../../components/Input/TextArea/TextAreaLbl";
import Lbl from "../../../../components/Label/Lbl";
import LabelDropdown from "../../../../components/Dropdown/LabelDropdown/LabelDropdown";
import LabelInput from "../../../../components/Input/LabelInput/LabelInput";
import {DatePicker, TimePicker, Tooltip} from "antd";
import * as DropDownConst from "../../../../store/Reducer/DropDownConst";
import IntlTelInput from "react-intl-tel-input";
import moment from "moment";
import Cookies from "js-cookie";
import axiosTags from "../../../../axios/axios_tag";
import apiConfig from "../../../../axios/axios_api_services";
import * as EmailValidator from "email-validator";
import floor_icon from "../../../../assets/img/recept_checkin/floor.svg";
import * as common from "../../../../const/Common/CommonFunc";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import * as util from "../../../../util/Validator";
import axios from "../../../../axios/axios_visitortag";
import Job from "../../../../components/IcsFileGenerator/ics";
import {notifyMessage} from "../../../../const/Common/CommonFunc";
import building_icon from "../../../../assets/img/recept_checkin/building.svg";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import './Style.css';
import ModernTimePicker from "../../../../components/TimePicker";

function disabledDate(current) {
  return current < moment().subtract(1, "days").endOf("day");

}

let xc = "";

class App extends React.Component {

  state = {

    hostId: "",
    hostName: "",

    meetingRefNo: "",
    meetingTitle: "",
    meetingDescription: "",
    meetingDate: "",
    meetingSTime: "",
    meetingETime: "",
    meetingBuilding: "",
    meetingBuildingId: "",
    meetingFloor: "",
    meetingPurpose: "",
    meetingFrequency: "",
    meetingUntil: "",

    oldMeetingTitle: "",
    oldMeetingDescription: "",
    oldMeetingBuilding: "",
    oldMeetingFloor: "",
    oldMeetingPurpose: "",
    oldMeetingDate: "",
    oldMeetingSTime: "",
    oldMeetingETime: "",
    oldMeetingFrequency: "",
    oldMeetingUntil: "",
    oldAttendeeListX: [],

    attendeeChange: true,
    attendeeUserId: "",
    attendeeSearch: "",
    attendeeType: "NIC",
    attendeeTitle: "Mr",
    attendeeIdentity: "",
    attendeeFName: "",
    attendeeLName: "",
    attendeeMobile: "",
    attendeeCompany: "",
    attendeeEMail: "",
    searchOptions: DropDownConst.IdentificationsHostWithoutVN(),

    attendeeValidMobile: false,
    attendeeValidEMail: false,
    attendeeValidIdentity: true,

    visitor_info_type: 'ADULT',
    children_list: [],
    repeatOpen: false,
    attendeesList: [],
    meetingFloorList: [],
    updateBtnDisable: true,
    t: [],

    s_visible: false,
    e_visible: false
  }


  disabledDateForUntil = (current) => {
    if (this.state.meetingDate !== '') {
      return current < moment(this.state.meetingDate, "YYYY-MM-DD").add(1, 'days');
    }

  }

  componentWillMount() {
    this.props.callAllBuildings(this.props.usr_obj);

  }

  componentDidMount() {
    if (this.props.usr_obj !== null || this.props.usr_obj !== "") {
      let meeting = this.props.meetingObj;
      // console.log(meeting)
      if(meeting !== null) {

        let untilDateTime = meeting.meetingSeries[meeting.meetingSeries.length-1].endTime;
        let untilDateTimeArray = untilDateTime.split(" ");
        let meetingUntilDate = untilDateTimeArray[0];
        let end_time = untilDateTimeArray[1];
        let meetingETime = end_time;

        let start_date_time1 = meeting.meetingSeries[0].startTime;
        let start_date_time_array1 = start_date_time1.split(" ");
        let start_date1 = start_date_time_array1[0];
        let start_time = start_date_time_array1[1];
        let meetingSDate = start_date1;
        let meetingSTime = start_time;

        let isRecurring = false;
        isRecurring = this.props.meetingObj.recurrentMeeting;

        let attendeesList = this.props.meetingObj.visitors;
        const attendeesListx = this.props.meetingObj.visitors;
        xc = this.props.meetingObj.visitors;
        let diff = "DAILY";
        if(meeting.meetingSeries.length > 1) {
          let start_date_time1 = meeting.meetingSeries[0].startTime;
          let start_date_time_array1 = start_date_time1.split(" ");
          let start_date1 = start_date_time_array1[0];

          let start_date_time2 = meeting.meetingSeries[1].startTime;
          let start_date_time_array2 = start_date_time2.split(" ");
          let start_date2 = start_date_time_array2[0];

          var date1 = new Date(start_date1);
          var date2 = new Date(start_date2);

          var Difference_In_Time = date2.getTime() - date1.getTime();

          var difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

          if(difference_In_Days === 7) {
            diff = "WEEKLY";
          }else if(difference_In_Days === 30) {
            diff = "MONTHLY"
          }else if(difference_In_Days === 365 || difference_In_Days === 366){
            diff = "YEARLY"
          }
        }

        // let fl = this.onHandleChangeBuildingFloorAuto(meeting.meetingSeries[0].building.building_id);

        this.setState({
          hostId: this.props.usr_obj.userId,
          hostName: "",

          meetingRefNo: meeting.refNo,
          meetingTitle: meeting.meetingSeries[0].title,
          meetingDescription: meeting.meetingSeries[0].description,
          meetingDate: meetingSDate,
          meetingSTime: meetingSTime,
          meetingETime: meetingETime,
          meetingBuilding: meeting.meetingSeries[0].building !== null ? meeting.meetingSeries[0].building.building_id : "N/A",
          meetingBuildingId: "",
          meetingFloor: meeting.meetingSeries[0].floor !== null ? meeting.meetingSeries[0].floor.floor_id : "N/A",
          meetingPurpose: meeting.meetingSeries[0].visitingPurpose,
          meetingFrequency: diff,
          meetingUntil: meetingUntilDate,

          oldMeetingTitle: meeting.meetingSeries[0].title,
          oldMeetingDescription: meeting.meetingSeries[0].description,
          oldMeetingBuilding: meeting.meetingSeries[0].building !== null ? meeting.meetingSeries[0].building.building_id : "N/A",
          oldMeetingFloor: meeting.meetingSeries[0].floor !== null ? meeting.meetingSeries[0].floor.floor_id : "N/A",
          oldMeetingPurpose: meeting.meetingSeries[0].visitingPurpose,
          oldMeetingDate: meetingSDate,
          oldMeetingSTime: meetingSTime,
          oldMeetingETime: meetingETime,
          oldMeetingFrequency: diff,
          oldMeetingUntil: meetingUntilDate,

          attendeeSearch: "",
          attendeeType: "NIC",
          attendeeTitle: "Mr",
          attendeeIdentity: "",
          attendeeFName: "",
          attendeeLName: "",
          attendeeMobile: "",
          attendeeCompany: "",
          attendeeEMail: "",

          attendeeValidMobile: false,
          attendeeValidEMail: false,
          attendeeValidIdentity: true,

          valid_search_mobile:false,
          mobile_confirmation_condi:false,
          search_mobile:'',
          search_mode: false,
          attendeeIdentifyType:'NIC',
          repeatOpen: isRecurring,
          attendeesList: attendeesList,
          meetingFloorList: [],
        });

      }
    }
  }

  onHandleChangeAttendeeChange = () => {
    // common.notifyMessage("You can't change attendee details");
  }

  callAllBuildings = (usr_obj) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b7")
    };
    let coperateId = usr_obj.corporates[0].corporateId;

    // Get All Buildings Of Corporate
    axiosTags.get(apiConfig.CORPORATE_BUILDINGS(coperateId), {headers: headers})
      .then(response => {
        if (response.data.success) {
          // dispatch(receptionAllBuildingHandler(response.data.buildingList));
        }
      })
      .catch(error => {
        // dispatch(checkErrorResponse(error, usr_obj, 1));
      });
  };

  changeRepeatOpen = () => {
    this.setState({
      repeatOpen: !this.state.repeatOpen
    });
  }

  onHandleChange = name => e => {
    let value = e.target.value;
    switch (name) {
      case "attendeeSearch":
        this.setState({attendeeSearch: value}); break;
      case "meetingTitle":
        this.setState({meetingTitle: value}); break;
      case "meetingDescription":
        this.setState({meetingDescription: value}); break;
      case "attendeeIdentity":
        this.setState({attendeeIdentity: value}); break;
      case "attendeeFName":
        this.setState({attendeeFName: value}); break;
      case "attendeeLName":
        this.setState({attendeeLName: value}); break;
      case "attendeeCompany":
        this.setState({attendeeCompany: value}); break;
      case "attendeeEMail":
        let validateEmail = EmailValidator.validate(value);
        this.setState({attendeeEMail: value, attendeeValidEMail: validateEmail});break;
      default: break;
    }
  }

  onHandleChangeFloor = (e, { value }) => {
    this.setState({
      meetingFloor: value
    });
  };

  onHandleChangePurpose = (e, { value }) => {
    this.setState({
      meetingPurpose: value
    });
  };

  onHandleChangeAttendeeTitle = (e, { value }) => {
    if(this.state.attendeeChange){
      this.setState({
        attendeeTitle: value
      });
    }
  };

  onHandleChangeMeetingFrequency = (e, { value }) => {
    this.setState({meetingFrequency: value})
  }

  onHandleMeetingDate = (date, dateString) => {
    let dateRange = moment("");
    this.setState({meetingDate: dateString});
  }

  onHandleChangeSTime = (time, timeString) => {
    this.setState({meetingSTime: timeString+":00"});
  }

  onHandleChangeETime = (time, timeString) => {
    this.setState({meetingETime: timeString+":00"});
  }

  onHandleChangeUntil = (until, untilString) => {
    this.setState({meetingUntil: untilString});
  }

  onHandleChangeBuilding = (e, { value }) => {
    let selectedMeetingBuilding = this.props.all_building_list[value];
    let floor_options = [];
    if (selectedMeetingBuilding.floors.length !== 0) {
      selectedMeetingBuilding.floors.map((element, index) => {
        floor_options.push({
          key: element.floor_id,
          text: element.description,
          value: element.floor_id,
          image: {avatar: true, src: floor_icon},
        })
      })
    }
    this.setState({meetingFloorList: floor_options, meetingBuildingId: selectedMeetingBuilding.buildingId, meetingBuilding: value});
  }

  onHandleChangeAttendeeMobile = (condition, value, object, withdialcode) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    this.setState({attendeeMobile: value, attendeeValidMobile: condition});
  }

  onHandleCustomPlaceholderForAttendeeMobile = (selectedCountryPlaceholder, selectedCountryData) => {
    // return selectedCountryData.dialCode + "XXXXXXXXXX";
    return "7XXXXXXXXX";
  }

  addAttendeeIntoQueue = () => {
    if (this.state.visitor_info_type === 'ADULT') {
      let isValidIdentify = util.identityValueValidator(this.state.attendeeIdentity.trim(), this.state.attendeeIdentifyType)
      if (isValidIdentify) {
        this.state.attendeeFName.trim() === '' ? common.notifyMessage("Please enter attendee first name") :
          this.state.attendeeLName.trim() === '' ? common.notifyMessage("Please enter attendee last name") :
            this.state.attendeeIdentity.trim() === '' ? common.notifyMessage("Please enter attendee identification") :
              !this.state.attendeeValidIdentity ? common.notifyMessage("Please enter valid identification for attendee") :
                this.state.attendeeMobile.trim() === '' ? common.notifyMessage("Please enter attendee mobile") :
                  !this.state.attendeeValidMobile ? common.notifyMessage("Please enter valid mobile for attendee") :
                    // this.state.attendeeCompany.trim().match(/[|\\/~^:,;?!&%$@*+]/)? common.notifyMessage("Please enter valid attendee company"):
                    this.state.children_list.length !== 0 ? this.addChildrenAction('save') : this.testMailValidation();
      }
    } else {
      this.addChildrenAction('save')
    }
  }

  testMailValidation = () => {
    if(this.state.attendeeEMail.trim() !== '') {
      if(!this.state.attendeeValidEMail) {
        common.notifyMessage("Please enter attendee email")
      }else{
        this.addAttendeeIntoQueueAdvanceValidate();
      }
    }else{
      this.addAttendeeIntoQueueAdvanceValidate();
    }
  }

  addAttendeeIntoQueueAdvanceValidate = () => {
    let a_id = this.state.attendeeIdentity;
    let u_id = this.props.usr_obj.identificationValue;
    if(a_id !== u_id) {
      this.addAttendeeIntoQueue_();
    }else{
      common.notifyMessage("Can't add host into attendee queue");
    }
  }

  addAttendeeIntoQueue_ = () => {
    if (!this.state.mobile_confirmation_condi) {
      swal({
        className: "swal-reception-number-check",
        text: "Please verify the mobile number of the attendee: " + this.state.attendeeMobile,
        icon: are_you_sure_icon,
        closeOnClickOutside: false,
        buttons: {
          cancel: 'Incorrect',
          dangerMode: {
            text: "Correct",
            value: "action",
            className: "okay-btn"
          }
        },
      }).then((value) => {

        switch (value) {
          case "action":
            this.addAttendeeIntoQueue__();
            break;
          default:
            break;
        }
      });
    }else {
      this.addAttendeeIntoQueue__();
    }
  }

  addAttendeeIntoQueue__ = () => {
    let attendeesList = this.state.attendeesList;
    let valid = true;
    for (let key in attendeesList) {
      let obj = attendeesList[key];
      if(obj.identificationValue === this.state.attendeeIdentity) {
        common.notifyMessage("An attendee is already in attendees queue with this identification. Please try another one");
        valid = false;
        break;
      }else if(obj.mobile === this.state.attendeeMobile) {
        common.notifyMessage("An attendee is already in attendees queue with this mobile. Please try another one");
        valid = false;
        break;
      }else if((this.state.attendeeEMail!==undefined && this.state.attendeeEMail!==null && this.state.attendeeEMail!=="") && (obj.email === this.state.attendeeEMail)) {
        common.notifyMessage("An attendee is already in attendees queue with this email. Please try another one");
        valid = false;
        break;
      }
    }
    if(valid) {this.addAttendeeIntoQueue___();}
  }

  addAttendeeIntoQueue___ = async () => {
    let children = []
    if (this.state.children_list.length !== 0 && this.state.visitor_info_type === 'ADULT') {
      this.state.children_list.map(item => {
        children.push({
          title: item.title,
          firstName: item.firstName,
          lastName: item.lastName,
          visitorType: 'CHILD'
        })
      })
    }

    let obj = {
      userId: this.state.attendeeUserId,
      title: this.state.visitor_info_type === 'ADULT' ? this.state.attendeeTitle : this.state.children_list[0].title,
      identificationValue: this.state.visitor_info_type === 'ADULT' ? this.state.attendeeIdentity : null,
      identificationType: this.state.visitor_info_type === 'ADULT' ? this.state.attendeeIdentifyType : null,
      firstName: this.state.visitor_info_type === 'ADULT' ? this.state.attendeeFName : this.state.children_list[0].firstName,
      lastName: this.state.visitor_info_type === 'ADULT' ? this.state.attendeeLName : this.state.children_list[0].lastName,
      mobile: this.state.attendeeMobile ? this.state.attendeeMobile : null,
      companyName: this.state.attendeeCompany?this.state.attendeeCompany:null,
      email: this.state.attendeeEMail?this.state.attendeeEMail:null,
      visitorType:this.state.visitor_info_type,
      children:this.state.visitor_info_type === 'ADULT' ? children : []
    };
    let attendeesList = this.state.attendeesList;
    this.state.visitor_info_type === 'CHILD' ? attendeesList = [obj] : attendeesList.push(obj)
    // if (!(this.state.visitor_info_type === 'CHILD' && this.state.attendeesList.length !== 0)) attendeesList.push(obj);
    await this.setState({attendeesList: attendeesList, attendeeChange: true, attendeeSearch:'', valid_search_mobile:false,
      search_mobile:'', attendeeIdentifyType:'NIC', mobile_confirmation_condi:false, search_mode:false,
      children_list: this.state.visitor_info_type === 'ADULT' ? [] : this.state.children_list });
    this.cleanAttendeeFields();

    if (this.state.visitor_info_type === 'CHILD') this.submit();
  }

  removeAttendeeFormList = (index, attendee, children) => {
    swal({
      className: "swal-reception-number-check",
      text: "Are you sure to remove attendee named " + attendee.firstName +" with mobile number "+attendee.mobile+" from queue?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Ok",
          value: "action",
          className: "okay-btn"
        }
      },
    }).then((value) => {

      switch (value) {
        case "action":
          this.removeAttendeeFormList_(index, children);
          break;
        default:
          break;
      }
    });
  }

  removeAttendeeFormList_ = (index, children) => {
    let attendeeArray = this.state.attendeesList;
    attendeeArray.splice(index,1);

    if (children.length !== 0) {
      children.map(child => attendeeArray.map((attendee,i) => {
        if (child.userId === attendee.userId) {
          attendeeArray.splice(i, 1);
        }
      }))
    }

    this.setState({
      attendeesList: attendeeArray
    });
  }

  //$#$#
  cleanAttendeeFields = () => {
    this.setState({
      attendeeTitle: "Mr",
      // attendeeSearch: "",
      attendeeType: "NIC",
      attendeeIdentity: "",
      attendeeFName: "",
      attendeeLName: "",
      attendeeMobile: "",
      attendeeCompany: "",
      attendeeEMail: "",
      attendeeValidMobile: false,
      attendeeValidEMail: false,
      attendeeValidIdentity: true,
    });
  }

  cleanAttendeeTbl = () => {
    this.setState({attendeesList: []});
  }

  cleanMeetingFields = () => {
    this.setState({
      attendeeChange: true,
      attendeeSearch: "",
      meetingTitle: "",
      meetingDescription: "",
      meetingDate: "",
      meetingSTime: "",
      meetingETime: "",
      meetingBuilding: "",
      meetingFloor: "",
      meetingPurpose: "",
      meetingFrequency: "",
      meetingUntil: "",
      repeatOpen: false
    });
  }

  searchAttendeeUsingIdentity = () => {
    let identity = this.state.attendeeSearch.trim();
    let isValidIdentity = false;
    if(this.state.attendeeType === "NIC" || this.state.attendeeType === "Passport" || this.state.attendeeType === "Driving Licence") {
      isValidIdentity = util.identityValueValidator(identity, this.state.attendeeType);
    } else if (this.state.attendeeType === "Mobile") {
      this.state.valid_search_mobile ? isValidIdentity = true : common.notifyMessage("Please add a valid mobile number.");
    } else if (this.state.attendeeType === "Email") {
      EmailValidator.validate(identity) ? isValidIdentity = true : common.notifyMessage("Please add a valid email.");
    } else {
      isValidIdentity = true;
    }

    let valid = this.searchDuplicatesInMeetingQueue();

    if (isValidIdentity && valid) {
      this.setState({ search_mode: true })
      this.cleanAttendeeFields();
      this.props.spinnerHandler(true);
      const headers = {"Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")};
      // const headers = {'Content-Type': 'application/json', "Authorization": "Bearer " + "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiJjdF9rYXZpbmR1Iiwic2NvcGUiOlsicmVhZCIsIndyaXRlIiwidHJ1c3QiXSwiZXhwIjoxNTk1OTMxNTAxLCJ1c2VyIjp7InVzZXJJZCI6MzUsInVzZXJOYW1lIjoiY3Rfa2F2aW5kdSIsImZ1bGxOYW1lIjoiS2F2aW5kdSBBa2FzaCBTYW1hcmFzaW5naGUiLCJlbWFpbCI6Im5ld3RlY2hzb2lsZGVyQGdtYWlsLmNvbSIsInN0YXR1cyI6MSwidXNlclJvbGVzIjoiUkVDRVBUSU9OIiwiY29ycG9yYXRlcyI6W3siY29ycG9yYXRlSWQiOjEsImNvcnBvcmF0ZUNvZGUiOiJDMDAxIiwiY29ycG9yYXRlTmFtZSI6IkNleWVudHJhIFRlY2hub2xvZ2llcyJ9XSwic2VydmljZXMiOlt7InNlcnZpY2VJZCI6MSwic2VydmljZU5hbWUiOiJQYXJrVGFnIFNlcnZpY2UifSx7InNlcnZpY2VJZCI6Miwic2VydmljZU5hbWUiOiJWaXNpdG9yVGFnIFNlcnZpY2UifV19LCJhdXRob3JpdGllcyI6WyJST0xFX1JFQ0VQVElPTiJdLCJqdGkiOiJlYWExMjAyYy1lYjA0LTQ5NTYtYjFhZi0xMTRhNzhhMWJiYTkiLCJjbGllbnRfaWQiOiJjZXllbnRyYSJ9.wOEaoPOlSjpVpfGDtvjYECIzW9lwolPtWYurY8SgTQQ"};

      let corporateId = this.props.usr_obj.corporates[0].corporateId;
      // let corporateId = 1;
      axios.get(apiConfig.CORPORATE_VISITOR_IDENTIFY_SEARCH({corporateId:corporateId,identifyValue:identity, searchType: this.state.attendeeType === "Mobile" ? `mobile` : this.state.attendeeType === "Email" ? 'email' : undefined}), { headers: headers })
        .then(response => {
          if (response.data.success) {
            let res = response.data.visitorList;
            if(res === undefined){
              if(response.data.visitor !== undefined){

                let visitor = response.data.visitor.visitor;

                this.setState({attendeeChange: false, mobile_confirmation_condi:true});

                this.selectAttendee(visitor);

              }
            }else if (res.length !== 0) {
              let attendee = res[0];
              this.setState({attendeeChange: false, mobile_confirmation_condi:true });
              this.selectAttendee(attendee.visitor);
            }
          } else {
            this.setState({
              attendeeIdentity: !(this.state.attendeeType === 'Mobile' || this.state.attendeeType === 'Email') ? this.state.attendeeSearch.trim() : "",
              attendeeUserId: 0,
              attendeeChange: true,
              attendeeMobile: this.state.attendeeType === 'Mobile' ? this.state.search_mobile.trim() : "",
              attendeeEMail: this.state.attendeeType === 'Email' ? this.state.attendeeSearch.trim() : "",
              attendeeValidMobile: this.state.attendeeType === 'Mobile',
              attendeeValidEMail: this.state.attendeeType === 'Email',
              attendeeIdentifyType: this.state.attendeeType === 'Mobile' || this.state.attendeeType === 'Email' ? 'NIC' : this.state.attendeeType
            })
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error, 'HOST');
          if (result === 1) {
            this.searchAttendeeUsingIdentity()
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        })
    }

  };

  searchDuplicatesInMeetingQueue = () => {
    let attendeesList = this.state.attendeesList;
    let valid = true;
    for (let key in attendeesList) {
      let obj = attendeesList[key];
      if (obj.guardianId === 0) {
        if (obj.identificationValue !== null || obj.mobile !== null || obj.email !== null) {
          if ((this.state.attendeeType === "NIC" || this.state.attendeeType === "Driving Licence" || this.state.attendeeType === "Passport") && obj.identificationValue.toLowerCase() === this.state.attendeeSearch.toLowerCase()) {
            common.notifyMessage("An attendee is already in attendees queue with this identification. Please try another one");
            valid = false;
            break;
          } else if (this.state.attendeeType === "Mobile" && (obj.mobile === this.state.search_mobile || obj.mobile.replace(/^0/, "") === this.state.search_mobile || obj.mobile === this.state.search_mobile.replace(/^0/, "") || obj.mobile === this.state.attendeeSearch)) {
            common.notifyMessage("An attendee is already in attendees queue with this mobile. Please try another one");
            valid = false;
            break;
          } else if (this.state.attendeeType === "Email" && (this.state.attendeeEMail !== undefined && this.state.attendeeEMail !== null && this.state.attendeeEMail !== "") && (obj.email === this.state.attendeeEMail)) {
            common.notifyMessage("An attendee is already in attendees queue with this email. Please try another one");
            valid = false;
            break;
          }
        }
      }
    }
    return valid;
  }

  selectAttendee = (attendee) => {
    let userId = attendee.userId;
    let attendeeIdentity = attendee.identificationValue === null || attendee.identificationValue === undefined ? this.state.visitor_identify : attendee.identificationValue;
    let attendeeCompany = attendee.companyName === null || attendee.companyName === "" || attendee.companyName === undefined ? "-" : attendee.companyName;
    let attendeeEMail = attendee.email === null || attendee.email === "" || attendee.email === undefined ? "" : attendee.email;
    let attendeeFName = attendee.firstName === null || attendee.firstName === "" || attendee.firstName === undefined ? "-" : attendee.firstName;
    let attendeeLName = attendee.lastName === null || attendee.lastName === "" || attendee.lastName === undefined ? "-" : attendee.lastName;
    let attendeeTitle = attendee.title === null || attendee.title === undefined ? "Mr" : attendee.title;
    let attendeeMobile = attendee.mobile === null || attendee.mobile === "" || attendee.mobile === undefined ? "" : attendee.mobile;
    let attendeeValidEMail = false;
    let attendeeValidMobile = false;
    attendeeEMail !== "" ? attendeeValidEMail = true : attendeeValidEMail = false;
    attendeeMobile !== "" ? attendeeValidMobile = true : attendeeValidMobile = false;
    this.setState({
      attendeeUserId: userId,
      attendeeTitle: attendeeTitle,
      attendeeIdentity: attendeeIdentity,
      attendeeFName: attendeeFName,
      attendeeLName: attendeeLName,
      attendeeMobile: attendeeMobile,
      attendeeCompany: attendeeCompany,
      attendeeEMail: attendeeEMail,
      attendeeValidMobile: attendeeValidMobile,
      attendeeValidEMail: attendeeValidEMail,
      attendeeValidIdentity: true,
    });

  }

  submit = () => {
    this.state.meetingTitle.trim() === ''? common.notifyMessage("Please enter meeting title"):
      this.state.meetingDescription.trim() === ''? common.notifyMessage("Please enter meeting description"):
        this.state.meetingDate.trim() === ''? common.notifyMessage("Please enter meeting date"):
          this.state.meetingSTime.trim() === ''? common.notifyMessage("Please enter meeting start time"):
            this.state.meetingETime.trim() === ''? common.notifyMessage("Please enter meeting end time"):
              (this.state.meetingSTime > this.state.meetingETime)? common.notifyMessage("Meeting start time can't be greater than meeting end time"):
                this.state.meetingBuilding === ''? common.notifyMessage("Please select meeting building"):
                  this.state.meetingFloor === ''? common.notifyMessage("Please select meeting floor"):
                    this.state.meetingPurpose === ''? common.notifyMessage("Please select meeting purpose"):
                      this.submit_();
  }

  submit_ = () => {
    if(this.state.repeatOpen) {
      this.state.meetingFrequency.trim() === ''? common.notifyMessage("Please select meeting frequency"):
        this.state.meetingUntil.trim() === ''? common.notifyMessage("Please enter end date of meeting repeat"):
          (this.state.meetingDate > this.state.meetingUntil)? common.notifyMessage("Meeting date can't be greater than meeting until repeat date"):
            this.submit__();
    }else{
      this.submit__();
    }
  }

  submit__ = () => {
    let cal = Job();
    let dateArray = (this.state.meetingDate).split("-");
    let timeArray = (this.state.meetingSTime).split(":");
    let untilArray = (this.state.meetingUntil).split("-");
    let days = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];
    let d = new Date(this.state.meetingDate);
    let dayName = days;
    if (this.state.meetingFrequency !== 'DAILY') {
      dayName = [days[d.getDay()]];
    }
    // let rule = {
    //   freq: this.state.meetingFrequency,
    //   interval: 1,
    //   dtstart: new Date(Date.UTC(dateArray[0], dateArray[1], dateArray[2], timeArray[0], timeArray[1])),
    //   until: new Date(Date.UTC(untilArray[0], untilArray[1], untilArray[2])),
    //   byday : dayName
    // };

    let rule = {
      freq: this.state.meetingFrequency,
      interval: 1,
      dtstart: this.state.meetingDate+" "+this.state.meetingSTime,
      until: this.state.meetingUntil,
      byday : dayName
    };

    let meetingIcs = null;
    let oldDate = this.state.oldMeetingDate;
    let oldSTime = this.state.oldMeetingSTime;
    let oldETime = this.state.oldMeetingETime;
    let oldFrequency = this.state.oldMeetingFrequency;
    let oldUntil = this.state.oldMeetingUntil;
    let newDate = this.state.meetingDate;
    let newSTime = this.state.meetingSTime;
    let newETime = this.state.meetingETime;
    let newFrequency = this.state.meetingFrequency;
    let newUntil = this.state.meetingUntil;

    let org_name = this.props.usr_obj.firstName + ' ' + this.props.usr_obj.firstName;
    let org_mail = this.props.usr_obj.email;
    let att_list = [];
    this.state.attendeesList.map((val, index) => {
      att_list.push(val.email);
    });

    // if(oldDate !== newDate || oldSTime !== newSTime || oldETime !== newETime || oldFrequency !== newFrequency || oldUntil !== newUntil) {
      if (!this.state.repeatOpen) {
        try {
          // meetingIcs = cal.addEvent(this.state.meetingTitle, this.state.meetingDescription, this.props.usr_obj.corporates[0].corporateId,
          //   this.state.meetingDate+" "+this.state.meetingSTime, this.state.meetingDate+" "+this.state.meetingETime);
          meetingIcs = cal.addEvent(this.state.meetingTitle, this.state.meetingDescription, "location",
            this.state.meetingDate + " " + this.state.meetingSTime, this.state.meetingDate + " " + this.state.meetingETime, null, org_name, org_mail, att_list, 2, this.state.meetingRefNo);

          if (this.state.visitor_info_type === "ADULT") {
            let attendList = this.state.attendeesList;
            let children = [];
            let children_list = [];
            let obj;
            attendList.map((attendee, index) => {
              if (attendee.guardianId === 0) {
                children = attendList.filter(item => attendee.userId === item.guardianId);
                children.map((child) => {
                  children_list.push({
                    title: child.title,
                    firstName: child.firstName,
                    lastName: child.lastName,
                    visitorType: "CHILD"
                  });
                })

                obj = {
                  companyName: attendee.companyName,
                  email: attendee.email,
                  firstName: attendee.firstName,
                  identificationValue: attendee.identificationValue,
                  lastName: attendee.lastName,
                  mobile: attendee.mobile,
                  title: attendee.title,
                  userId: attendee.userId,
                  visitorType: "ADULT",
                  children: children_list
                }
                attendList.splice(index, 1, obj);
              }
            })

            attendList.map((attendee, index) => {
              if (attendee.identificationValue === null && attendee.mobile === null && attendee.email === null) {
                attendList.splice(index, 1);
              }
            })


            let meetingObj = {
              meeting: {
                refNo: this.state.meetingRefNo,
                hostA: this.state.hostId,
                floorId: this.state.meetingFloor,
                // floorId: 1,
                visitingPurpose: this.state.meetingPurpose,
                title: this.state.meetingTitle,
                description: this.state.meetingDescription,
                visitors: attendList,
                icsContent: meetingIcs
              }
            }
          }


          let meetingObj = {
            meeting: {
              refNo: this.state.meetingRefNo,
              hostA: this.state.hostId,
              floorId: this.state.meetingFloor,
              // floorId: 1,
              visitingPurpose: this.state.meetingPurpose,
              title: this.state.meetingTitle,
              description: this.state.meetingDescription,
              visitors: this.state.attendeesList,
              icsContent: meetingIcs
            }
          }

          this.submit___(meetingObj);

        } catch (e) {
          notifyMessage("Something went wrong!", 1, 3);
        }

      } else {
        try {
          meetingIcs = cal.addEvent(this.state.meetingTitle, this.state.meetingDescription, this.props.usr_obj.corporates[0].corporateId,
            this.state.meetingDate + " " + this.state.meetingSTime, this.state.meetingDate + " " + this.state.meetingETime, rule, org_name, org_mail, att_list, 2, this.state.meetingRefNo);

          if (this.state.visitor_info_type === "ADULT") {
            let attendList = this.state.attendeesList;
            let children = [];
            let children_list = [];
            let obj;
            attendList.map((attendee, index) => {
              if (attendee.guardianId === 0) {
                children = attendList.filter(item => attendee.userId === item.guardianId);
                children.map((child) => {
                  children_list.push({
                    title: child.title,
                    firstName: child.firstName,
                    lastName: child.lastName,
                    visitorType: "CHILD"
                  });
                })

                obj = {
                  companyName: attendee.companyName,
                  email: attendee.email,
                  firstName: attendee.firstName,
                  identificationValue: attendee.identificationValue,
                  lastName: attendee.lastName,
                  mobile: attendee.mobile,
                  title: attendee.title,
                  userId: attendee.userId,
                  visitorType: "ADULT",
                  children: children_list
                }
                attendList.splice(index, 1, obj);
              }
            })

            attendList.map((attendee, index) => {
              if (attendee.identificationValue === null && attendee.mobile === null && attendee.email === null) {
                attendList.splice(index, 1);
              }
            })

            let meetingObj = {
              meeting: {
                refNo: this.state.meetingRefNo,
                hostA: this.state.hostId,
                floorId: this.state.meetingFloor,
                // floorId: 1,
                visitingPurpose: this.state.meetingPurpose,
                title: this.state.meetingTitle,
                description: this.state.meetingDescription,
                visitors: attendList,
                icsContent: meetingIcs
              }
            }
          }


          let meetingObj = {
            meeting: {
              refNo: this.state.meetingRefNo,
              hostA: this.state.hostId,
              floorId: this.state.meetingFloor,
              // floorId: 1,
              visitingPurpose: this.state.meetingPurpose,
              title: this.state.meetingTitle,
              description: this.state.meetingDescription,
              visitors: this.state.attendeesList,
              icsContent: meetingIcs
            }
          }
          this.submit___(meetingObj);
        } catch (e) {
          notifyMessage("Something went wrong!", 1, 3);
        }

      }
    // }else{
    //   let meetingObj = {
    //     meeting: {
    //       refNo: this.props.meetingObj.refNo,
    //       hostA: this.state.hostId,
    //       floorId: this.state.meetingFloor,
    //       // floorId: 1,
    //       visitingPurpose: this.state.meetingPurpose,
    //       title: this.state.meetingTitle,
    //       description: this.state.meetingDescription,
    //       visitors: this.state.attendeesList,
    //       icsContent: null
    //     }
    //   }
    //
    //   this.submit___(meetingObj);
    // }

  }

  submit___ = (meetingObj) => {
    swal({
      title: "Are you sure you want to update?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.sendToBackEnd(meetingObj);
            break;
          default:
        }
      });
  };

  sendToBackEnd = (meetingObj) => {

    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    this.props.spinnerHandler(true);
    axios.patch(apiConfig.HOST_UPDATE_MEETING({corporateId: corporateId}), meetingObj, { headers: headers })
      .then(response => {
        let result = response.data.success;
        if (result) {
          this.cleanAttendeeFields();
          this.cleanAttendeeTbl();
          this.cleanMeetingFields();
          this.props.setMeetingHost(response.data.meetings[0]);
          common.warningAlert("Meeting has been updated", 0);
          // this.props.callAllBuildings(this.props.usr_obj);

        } else {
          this.props.spinnerHandler(false);
          common.warningAlert(response.data.message, 1)
        }
      }).catch(async error => {
      if (error.response.status === 417) {
        common.warningAlert("Something went wrong!", 1);
      } else {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackEnd();
        } else {
          this.props.spinnerHandler(false)
        }
      }

    })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  }

  // OnHandleChangeBuilding = (e, { value }) => {
  //   let selectedBuilding = this.props.all_building_list[value];
  //
  //   const floor_options = [];
  //   if (selectedBuilding.floors.length !== 0) {
  //     selectedBuilding.floors.map((element, index) => {
  //       floor_options.push({
  //         key: element.floor_id,
  //         text: element.description,
  //         value: element.floor_id,
  //         image: { avatar: true, src: floor_icon },
  //       })
  //     })
  //   }
  //
  //   this.setState({
  //     meeting_building: value,
  //     meeting_building_id: selectedBuilding.buildingId
  //   });
  //   this.props.receptionAllFloorHandler(floor_options);
  // };

  toggle = () => {}

  handleAdultChildBtn = (type) => {
    this.setState({ visitor_info_type:type });
    // type === 'ADULT' ? this.setState({children_list:[], attendeesList:[] }) :
    //   this.setState({children_list:[{title:'', firstName:'', lastName:''}], attendeesList:[] })
    if (type === 'CHILD') {
      this.setState({children_list:[{title:'', firstName:'', lastName:'' }] });
    }
  }

  addChildrenAction = (type) => {
    let isvalid = false
    if (this.state.children_list.length !== 0) {
      this.state.children_list.map((item,i) => {
        if (item.title === '' || item.firstName === '' || item.lastName === '') {
          common.notifyMessage(this.state.visitor_info_type === 'ADULT' ? "Please fill all details of Child "+(i+1) :
            "Please fill all details of the child " );
          isvalid = true
        }
      })
    }
    if (!isvalid) {
      switch (type) {
        case 'add':
          this.state.children_list.push({title:'', firstName:'', lastName:''})
          this.forceUpdate()
          break;
        case 'save':
          this.state.visitor_info_type === 'ADULT' ? this.testMailValidation() : this.addAttendeeIntoQueue___()
          break;
      }
    }
  }

  handleChildrenList = (id,type,value) => {
    switch (type) {
      case "title":
        this.state.children_list[id].title = value
        break;
      case "firstName":
        this.state.children_list[id].firstName = value
        break;
      case "lastName":
        this.state.children_list[id].lastName = value
        break;
    }
    this.forceUpdate()
  }

  removeChild = (id) => {
    this.state.children_list.splice(id,1);
    this.forceUpdate();
  }

  onHandleChangeHostMobile = (condition, value, object, withdialcod) => {
    value = value.startsWith("00") ? "+" + value.substr(2) : value;
    condition = util.customMobileValidation(withdialcod.substr(1).replace(/\s/g, ""),condition);
    this.setState({
      valid_search_mobile:condition,
      search_mobile:value,
      attendeeSearch: withdialcod.substr(1).replace(/\s/g, "")
    });
  };

  identifyTypeOnChange = (e, { value }) => {
    this.setState({
      attendeeIdentifyType: value
    });
  };

  clockVisibleChanger = (value) => {
    switch (value) {
      case "S":
        this.setState({
          s_visible: true,
          e_visible: false
        });
        break;
      case "E":
        this.setState({
          s_visible: false,
          e_visible: true
        });
        break;
      case "SV":
        this.setState({
          s_visible: false,
        });
        break;
      case "EV":
        this.setState({
          e_visible: false
        });
        break;
    }
  };


  render() {

    let floor_options = [];
    if(this.state.meetingBuilding !== "") {
      let selectedMeetingBuilding = this.props.all_building_list[this.state.meetingBuilding];
      if(selectedMeetingBuilding!== undefined) {
        if (selectedMeetingBuilding.floors.length !== 0) {
          selectedMeetingBuilding.floors.map((element, index) => {
            // console.log(element);
            floor_options.push({
              key: element.floor_id,
              text: element.description,
              value: element.floor_id,
              image: {avatar: true, src: floor_icon},
            })
          })
        }
      }
    }


    const options = [
      { key: '.com', text: '.com', value: '.com' },
      { key: '.net', text: '.net', value: '.net' },
      { key: '.org', text: '.org', value: '.org' },
    ]

    const optionsOfRecurrence = [
      { key: 'DAILY', text: 'DAILY', value: 'DAILY' },
      { key: 'WEEKLY', text: 'WEEKLY', value: 'WEEKLY' },
      { key: 'MONTHLY', text: 'MONTHLY', value: 'MONTHLY' },
      { key: 'YEARLY', text: 'YEARLY', value: 'YEARLY' },
    ]

    let meetingDateOnPicker = this.state.meetingDate !== ""?moment(this.state.meetingDate, "YYYY-MM-DD"):null;
    let meetingSTimePicker = this.state.meetingSTime !== ""?moment(this.state.meetingSTime, "HH:mm:ss"):null;
    let meetingETimePicker = this.state.meetingETime !== ""?moment(this.state.meetingETime, "HH:mm:ss"):null;
    let meetingUntilOnPicker = this.state.meetingUntil !== ""?moment(this.state.meetingUntil, "YYYY-MM-DD"):null;

    let recurrence_details = <div className="repeat-block">

      <Row className="">
        <Col lg={5} className="TimePickerCol">
          <Lbl required>Frequency</Lbl>
          <Dropdown
            placeholder='Select Frequency'
            fluid
            selection
            value={this.state.meetingFrequency}
            options={optionsOfRecurrence}
            onChange={this.onHandleChangeMeetingFrequency}/>
        </Col>
        <Col lg={6} className="TimePickerCol">
          <Lbl required>Until</Lbl>
          <DatePicker
            className="the-time-piker"
            disabledDate={this.disabledDateForUntil}
            disabled={this.state.meetingDate === ''?true:false}
            style={{width:'100%'}} value={meetingUntilOnPicker}
            onChange={this.onHandleChangeUntil}/>
          {
            this.state.meetingDate === ''?
              <span style={{color:"#ef5350"}}>*Please set meeting start date before set until date</span>:""
          }

        </Col>
      </Row>

    </div>;

    let allBuildingsList = this.props.all_building_list;
    // let {visitors_purpose_options_list} = this.props;
    let visitors_purpose_options_list = this.props.purpose_options_list;
    const building_options = [];
    if (allBuildingsList.length !== 0) {
      allBuildingsList.map((element, index) => {
        building_options.push({
          key: index,
          text: element.name,
          value: index,
          image: { avatar: true, src: building_icon },
        })
      })
    }

    let attendees_col = [
      {
        label: 'Identification',
        field: 'id',
        sort: 'asc'
      },
      {
        label: 'First Name',
        field: 'fname',
        sort: 'asc'
      },
      {
        label: 'Last Name',
        field: 'lname',
        sort: 'asc'
      },
      {
        label: 'Mobile',
        field: 'mobile',
        sort: 'asc'
      },
      {
        label: 'Children',
        field: 'children',
        sort: 'asc'
      },
      {
        label: 'Remove',
        field: 'remove',
        sort: 'asc'
      }

    ];
    let attendees_rows = [];
    if (this.state.attendeesList.length !== 0) {
      this.state.attendeesList.map((attendee, index) => {
        console.log(attendee);
        let children = [];

        // console.log(attendee);
        if (attendee.guardianId === 0) {
          children = this.state.attendeesList.filter(item => attendee.userId === item.guardianId);
          let childrenString = ''
          if (children.length !== 0) {
            children.map(item => [
              childrenString += ", " + item.firstName + " " + item.lastName
            ])
            childrenString = childrenString.substring(1)
          }

          const obj = {
            id: attendee.identificationValue,
            fname: attendee.firstName,
            lname: attendee.lastName,
            mobile: attendee.mobile,
            children: childrenString,
            remove:
              <Tooltip placement="topLeft" title={"Remove " + attendee.firstName}>
                <SementicBtn circular icon='trash alternate' className={"more-remove-card"}
                             onClick={() => this.removeAttendeeFormList(index, attendee, children)}
                />
              </Tooltip>
          };

          attendees_rows.push(obj);
        }

        if (attendee.visitorType === 'ADULT') {
          let childrenString = ''
          if (attendee.children.length !== 0) {
            attendee.children.map(item => [
              childrenString += ", "+item.firstName+" "+item.lastName
            ])
            childrenString = childrenString.substring(1)
          }

          const obj = {
            id: attendee.identificationValue,
            fname: attendee.firstName,
            lname: attendee.lastName,
            mobile: attendee.mobile,
            children: childrenString,
            remove:
              <Tooltip placement="topLeft" title={"Remove " + attendee.firstName}>
                <SementicBtn circular icon='trash alternate' className={"more-remove-card"}
                             onClick={() => this.removeAttendeeFormList(index, attendee, children)}
                />
              </Tooltip>
          };

          attendees_rows.push(obj);
        }

      })
    }
    let attendees_table_data = { columns: attendees_col, rows: attendees_rows };

    let childrenDiv = []
    if (this.state.children_list.length !== 0) {
      this.state.children_list.map((item,index) => {
        let temp = index + 1
        childrenDiv.push(<div style={{marginTop:'2rem'}} key={index}>
          {this.state.visitor_info_type === 'ADULT' && <h6 style={{fontWeight:600}}>{"Child "+ temp}</h6>}
          <Row>
            <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
              <LabelDropdown
                required
                // disable={this.state.isVisitor}
                tagText={"Title"}
                placeholder={"Select Title"}
                options={DropDownConst.userTitle}
                value={item.title}
                onChange={(e,{value}) => this.handleChildrenList(index,'title',value)}
              />
            </Col>
            <Col lg="6" md={"12"} sm={"12"} xs={"12"}></Col>
            <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
              <LabelInput
                // disable={this.state.isVisitor}
                required
                tagText={"First Name"}
                placeholder={"First Name"}
                value={item.firstName}
                onChange={(e) => this.handleChildrenList(index,'firstName',e.target.value)}
              />
            </Col>

            <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
              <LabelInput
                // disable={this.state.isVisitor}
                required
                tagText={"Last name"}
                placeholder={"Last name"}
                value={item.lastName}
                onChange={(e) => this.handleChildrenList(index,'lastName',e.target.value)}
              />
            </Col>
            {this.state.visitor_info_type === 'ADULT' && <Col>
              <div className={'rv-child'}><p><a onClick={() => this.removeChild(index)}>Remove</a></p></div>
            </Col>}
          </Row>
        </div>)
      })
    }

    return(
      <div>
        {/*<h5 className="topicColor">Schedule a Meeting</h5>*/}
        <MDBModal isOpen={true} toggle={this.toggle} size="xl">
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Edit Meeting</MDBModalHeader>
          <MDBModalBody>
          <Row className="main-row-padding">
          {/*--------------------------------------------------------------------------------------------------------------*/}
          <Col xs="12" lg={"6"} md={"12"}>
            <Card>
              <CardHeader>
                {/*Meeting Informations*/}
                MEETING INFORMATION
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  <Row style={{padding: '10px'}}>

                    <Col lg={12}>

                      <Form>

                        <Form.Group widths='equal'>
                          <TxtLbl
                            required
                            tagText={"Title"}
                            placeholder={"Title"}
                            value={this.state.meetingTitle}
                            onChange={this.onHandleChange('meetingTitle')}
                          />
                        </Form.Group>

                        <Form.Group widths='equal'>
                          <TxtAreaLbl
                            required
                            tagText={"Description"}
                            placeholder={"Description"}
                            value={this.state.meetingDescription}
                            onChange={this.onHandleChange('meetingDescription')}
                          />
                        </Form.Group>

                      </Form>
                      <Row className="TimePickerRow">
                        <Col lg={5} className="TimePickerCol">
                          <Lbl required>Meeting Date</Lbl>
                          <DatePicker
                            style={{width:'100%'}}
                            disabledDate={disabledDate}
                            value={meetingDateOnPicker}
                            onChange={this.onHandleMeetingDate}/>
                        </Col>
                        <Col lg={6} className="TimePickerCol">
                          <Row>
                            <Col lg={6} className="TimePickerCol">
                              <Lbl required>Start Time</Lbl>
                              <ModernTimePicker
                                unic= {"S"}
                                time={ this.state.meetingSTime }
                                change={ this.onHandleChangeSTime }
                                visible= {this.state.s_visible}
                                visi= { this.clockVisibleChanger } />
                              {/*<TimePicker
                                id={"id001x251"}
                                value={meetingSTimePicker}
                                onChange={this.onHandleChangeSTime}
                                // use12Hours
                                format="HH:mm"
                              />*/}
                            </Col>
                            <Col lg={6} className="TimePickerCol">
                              <Lbl required>End Time</Lbl>
                              <ModernTimePicker
                                unic= {"E"}
                                time={ this.state.meetingETime }
                                change={ this.onHandleChangeETime }
                                visible= {this.state.e_visible}
                                visi= { this.clockVisibleChanger } />
                              {/*<TimePicker
                                id={"id001x252"}
                                value={meetingETimePicker}
                                onChange={this.onHandleChangeETime}
                                // use12Hours
                                format="HH:mm"
                              />*/}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row className="TimePickerRow">
                        <Col lg={5} className="TimePickerCol">
                          <Lbl>Repeat<Icon name='sync alternate' /></Lbl>
                          <Checkbox toggle
                                    checked = {this.state.repeatOpen}
                                    onChange={this.changeRepeatOpen}
                          />
                        </Col>
                      </Row>
                      {
                        this.state.repeatOpen?
                          recurrence_details:""
                      }
                      <Row className="TimePickerRow">
                        <Col lg={12} className="TimePickerCol">
                          <Lbl required>Meeting Building</Lbl>
                          <Dropdown
                            placeholder='Select Building'
                            fluid
                            selection
                            value={this.state.meetingBuilding}
                            options={building_options}
                            onChange={this.onHandleChangeBuilding}
                          />
                        </Col>
                      </Row>

                      <Row className="TimePickerRow">
                        <Col lg={12} className="TimePickerCol">
                          <Lbl required>Meeting Floor</Lbl>
                          <Dropdown
                            placeholder='Meeting Floor'
                            fluid
                            selection
                            value={this.state.meetingFloor}
                            options={floor_options}
                            onChange={this.onHandleChangeFloor}
                          />
                        </Col>
                      </Row>

                      <Row className="TimePickerRow">
                        <Col lg={12} className="TimePickerCol">
                          <Lbl required>Meeting Purpose</Lbl>
                          <Dropdown
                            placeholder='Meeting Purpose'
                            fluid
                            selection
                            value={this.state.meetingPurpose}
                            options={visitors_purpose_options_list}
                            onChange={this.onHandleChangePurpose}
                          />
                        </Col>
                      </Row>

                    </Col>
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
          {/*--------------------------------------------------------------------------------------------------------------*/}
          <Col xs="12" lg={"6"} md={"12"}>
            <Card>
              <CardHeader>
                {/*Meeting Attendees*/}
                MEETING ATTENDEES
              </CardHeader>
              <Collapse isOpen={true} id="collapseExample">
                <CardBody>

                  <div className="minor-div">
                    <Button onClick={() => this.handleAdultChildBtn('ADULT')} className={this.state.visitor_info_type === 'ADULT' ? "active_btn" : "inactive_btn"}>Adult</Button>
                    <Button onClick={() => this.handleAdultChildBtn('CHILD')} className={this.state.visitor_info_type === 'CHILD' ? "active_btn" : "inactive_btn"}>Child</Button>
                    <hr/>
                  </div>


                  {
                    this.state.visitor_info_type  === 'ADULT' ? <>
                  <Form>
                    <Row>
                      <Col lg={"9"} md={"8"} sm={"8"} xs={"8"}>
                        {
                          this.state.attendeeType === 'Mobile' ?
                            <div className={"display-inline"} id="mobile-input">
                              <IntlTelInput
                                style={{width: '100%'}}
                                type={"text"}
                                fieldName={"Mobile Number"}
                                value={this.state.search_mobile}
                                containerClassName="intl-tel-input dashboard-intl"
                                inputClassName="form-control"
                                onPhoneNumberChange={this.onHandleChangeHostMobile}
                                required={true}
                                preferredCountries={['lk']}
                                defaultCountry={"lk"}
                                nationalMode={false}
                                icon='mobile alternate'
                                placeholder="7XXXXXXXXX"
                                // customPlaceholder={this.customPlaceholder}
                              />
                              <Dropdown
                                style={{borderTopLeftRadius:0, borderBottomLeftRadius:0, display:'flex'}}
                                button basic floating
                                value={this.state.attendeeType}
                                options={this.state.searchOptions}
                                onChange={
                                  (e, {value}) => {
                                    this.setState({
                                      attendeeType: value, attendeeSearch:""
                                    })
                                  }
                                }
                              />
                            </div>:
                            <Input
                              className="xx"
                              action={
                                <Dropdown
                                  button basic floating
                                  value={this.state.attendeeType}
                                  options={this.state.searchOptions}
                                  onChange={
                                    (e, {value}) => {
                                      this.setState({
                                        attendeeType: value, attendeeSearch:""
                                      })
                                    }
                                  }
                                />
                              }
                              icon='search'
                              iconPosition='left'
                              placeholder='Search Here'
                              value={this.state.attendeeSearch}
                              onChange={this.onHandleChange("attendeeSearch")}
                            />
                        }
                      </Col>
                      <Col lg={"3"} md={"4"} sm={"4"} xs={"4"} className="search-visitor-col">
                        <SementicBtn onClick={this.searchAttendeeUsingIdentity} className="px-5 search-visitor-btn">Search</SementicBtn>
                      </Col>
                    </Row>
                  </Form>
                  <br/>

                  {
                    this.state.search_mode && <>

                      <Row className="TimePickerRow">
                        <Col lg={6} className="TimePickerCol">
                          <Lbl required>Title</Lbl>
                          <Dropdown
                            placeholder='Select Title'
                            fluid
                            selection
                            value={this.state.attendeeTitle}
                            options={DropDownConst.userTitle}
                            onChange={this.state.attendeeChange ? this.onHandleChangeAttendeeTitle : this.onHandleChangeAttendeeChange}
                          />
                        </Col>
                        {
                          (this.state.attendeeType === 'Email' || this.state.attendeeType === 'Mobile') &&
                          <Col lg={6}></Col>
                        }
                        <Col lg={6} className="TimePickerCol">

                          <Form>

                            <Form.Group widths='equal' style={{paddingTop: "10px"}}>
                              <TxtLbl
                                required
                                tagText={"Identification"}
                                placeholder={"Identification"}
                                value={this.state.attendeeIdentity}
                                onChange={this.state.attendeeChange && (this.state.attendeeType === 'Email' || this.state.attendeeType === 'Mobile') ? this.onHandleChange('attendeeIdentity') : this.onHandleChangeAttendeeChange}
                              />
                            </Form.Group>
                          </Form>

                        </Col>
                        {
                          (this.state.attendeeType === 'Email' || this.state.attendeeType === 'Mobile') &&
                          <Col lg="6" md={"12"} sm={"12"} xs={"12"}>
                            <Lbl required>Identity Type</Lbl>
                            <Dropdown
                              placeholder='Select Type'
                              fluid
                              selection
                              value={this.state.attendeeIdentifyType}
                              options={DropDownConst.Identifications}
                              onChange={this.state.attendeeChange ? this.identifyTypeOnChange : this.onHandleChangeAttendeeChange}
                            />
                          </Col>

                        }
                      </Row>

                      <Row className="TimePickerRow">
                        <Col lg={6} className="TimePickerCol">

                          <Form>

                            <Form.Group widths='equal'>
                              <TxtLbl
                                required
                                tagText={"First Name"}
                                placeholder={"First Name"}
                                value={this.state.attendeeFName}
                                onChange={this.state.attendeeChange ? this.onHandleChange('attendeeFName') : this.onHandleChangeAttendeeChange}
                              />
                            </Form.Group>
                          </Form>

                        </Col>
                        <Col lg={6} className="TimePickerCol">

                          <Form>

                            <Form.Group widths='equal'>
                              <TxtLbl
                                required
                                tagText={"Last Name"}
                                placeholder={"Last Name"}
                                value={this.state.attendeeLName}
                                onChange={this.state.attendeeChange ? this.onHandleChange('attendeeLName') : this.onHandleChangeAttendeeChange}
                              />
                            </Form.Group>
                          </Form>

                        </Col>
                      </Row>
                      <Row className="TimePickerRow">
                        <Col lg="6" md={"12"} sm={"12"} xs={"12"} style={{marginTop: '-12px'}}>
                          <Lbl style={{display: "block"}} required>Mobile</Lbl>
                          <IntlTelInput
                            id={"id001x253"}
                            style={{width: '100%'}}
                            type={"text"}
                            fieldName={"Mobile Number"}
                            value={this.state.attendeeMobile}
                            containerClassName="intl-tel-input dashboard-intl"
                            inputClassName="form-control"
                            onPhoneNumberChange={this.state.attendeeChange ? this.onHandleChangeAttendeeMobile : this.onHandleChangeAttendeeChange}
                            required={true}
                            preferredCountries={['lk']}
                            defaultCountry={"lk"}
                            nationalMode={false}
                            customPlaceholder={this.onHandleCustomPlaceholderForAttendeeMobile}
                          />
                        </Col>
                        <Col lg={6} className="TimePickerCol">

                          <Form>

                            <Form.Group widths='equal'>
                              <TxtLbl
                                tagText={"Company"}
                                placeholder={"Company"}
                                value={this.state.attendeeCompany}
                                onChange={this.state.attendeeChange ? this.onHandleChange('attendeeCompany') : this.onHandleChangeAttendeeChange}
                              />
                            </Form.Group>
                          </Form>

                        </Col>
                      </Row>
                      <Row className="TimePickerRow">
                        <Col lg={12} className="TimePickerCol">

                          <Form>

                            <Form.Group widths='equal'>
                              <TxtLbl
                                tagText={"Email"}
                                placeholder={"Email"}
                                value={this.state.attendeeEMail}
                                onChange={this.state.attendeeChange && this.state.attendeeType !== 'Email' ? this.onHandleChange('attendeeEMail') : this.onHandleChangeAttendeeChange}
                              />
                            </Form.Group>
                          </Form>

                        </Col>

                      </Row>

                      {childrenDiv}

                      <div className="add-child-div" onClick={() => this.addChildrenAction('add')}>
                        <Icon type="plus" style={{fontSize: '16px', color: '#08c'}} theme="outlined"/>Add Children
                      </div>

                    </>
                  }

                  {
                    ((this.state.search_mode && this.state.visitor_info_type === 'ADULT') || this.state.visitor_info_type === 'CHILD') &&
                    <Row>
                      <Col sm={12}
                           style={{padding: '0px', textAlign: 'right', marginBottom: '7px', marginLeft: '-10px'}}>
                        <SementicBtn icon
                                     onClick={this.addAttendeeIntoQueue}
                                     // className={'addToAttendeeQueue'}
                        >
                          <Icon name='angle down' className="animated infinite bounce delay-2s"/>
                          Add to Attendee queue
                        </SementicBtn>
                      </Col>
                    </Row>
                  }
                    </> : <>
                      { childrenDiv }
                    </>
                  }

                  {this.state.visitor_info_type  === 'ADULT' ? <hr/> : null}

                  <Row>
                    {
                      this.state.attendeesList.length !== 0 && this.state.visitor_info_type  === 'ADULT' ?
                        <Col sm={12} style={{ padding: '10px' }}>
                          <MDBDataTable
                            responsive
                            responsiveSm
                            responsiveMd
                            responsiveLg
                            responsiveXl
                            id={"visitors-details-table"}
                            paging={false}
                            searching={false}
                            bordered
                            hover
                            data={attendees_table_data} />
                        </Col>
                        : null
                    }
                    {

                      this.state.attendeesList.length !== 0 || this.state.visitor_info_type === 'CHILD' ?
                        <Col sm={12} style={{ padding: '10px', textAlign: "center" }}>
                          <SementicBtn
                            // id="sbtn"
                            className={'submit-btn ui button'}
                            onClick={this.state.visitor_info_type === 'ADULT' ? this.submit : () => this.addChildrenAction('save')}>Update</SementicBtn></Col>:null
                    }
                  </Row>
                </CardBody>
              </Collapse>
            </Card>
          </Col>
          {/*--------------------------------------------------------------------------------------------------------------*/}

        </Row>
          </MDBModalBody>
        </MDBModal>
      </div>



    );

  }

}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  purpose_options_list: state.reception_SheduleMeetingReducer.visitors_purpose_options_list,
  all_building_list: state.reception_SheduleMeetingReducer.all_building_list,
  all_floor_list: state.reception_SheduleMeetingReducer.all_floor_list,
  meetingObj: state.hostReducer.meetingObj,
  meetingObj2: state.hostReducer.meetingObj2,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    setMeetingHost: (data) => dispatch(actionCreator.setMeetingHost(data)),
    callAllBuildings: (data) => dispatch(actionCreator.callAllBuildingsForHost(data)), // Get All Buildings Of Corporate
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);















